import { computed, observable, action, makeObservable } from 'mobx';
import { groupBy } from 'lodash';
import { customerService } from 'config/ioc';
import { PENDING, FULFILLED, REJECTED } from 'constants/actions';

class CustomersStore {
  fetchState;

  customers = [];

  prevScroll = null;

  queryParams = {};

  constructor() {
    makeObservable(this, {
      fetchState: observable,
      customers: observable.ref,
      getCustomers: action.bound,
      clearCustomers: action,
      teams: computed,
    });
  }

  async getCustomers(params) {
    this.fetchState = PENDING;
    try {
      const response = await customerService.getCustomers(params);
      const customers = response.data.data.items;
      this.queryParams = params;
      this.customers = customers;
      this.fetchState = FULFILLED;
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  clearCustomers() {
    this.customers = [];
    this.fetchState = null;
  }

  get teams() {
    return groupBy(this.customers, 'team.id');
  }
}

const customersStore = new CustomersStore();

export default customersStore;
